import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from '../Footer/Footer';
import VideoBackground from '../VideoBackground/VideoBackground';
import styles from './Layout.module.css';

export default function Layout() {
  return (
    <div className={styles.layout}>
      <VideoBackground />
      <Navbar />
      <main className={styles.main}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
